import { render, staticRenderFns } from "./MemberCuration.vue?vue&type=template&id=26408ac0&scoped=true&"
import script from "./MemberCuration.vue?vue&type=script&lang=js&"
export * from "./MemberCuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26408ac0",
  null
  
)

export default component.exports